module.exports = __webpack_public_path__ + "assets/725b87485cb70c625d272bfa50bffd1e.png";